// src/components/PageContainer.jsx
import React from "react";
import LoaderOverlay from "./LoaderOverlay";
import useDelayedProgressLoader from "../hooks/useDelayedProgressLoader";

export default function PageContainer({
    isLoading,
    error,
    children,
    loadingText = "Loading data...",
    showOverlay = true,
}) {
    const { isLoaderVisible, isProgressMode, progress } =
        useDelayedProgressLoader(isLoading);

    // Option 1: overlay complete
    if (showOverlay && isLoaderVisible) {
        return (
            <>
                <LoaderOverlay
                    text={loadingText}
                    mode={isProgressMode ? "progress" : "normal"}
                    progress={progress}
                />
                {/* You can let an empty background behind if you want */}
            </>
        );
    }

    // Option 2: inline loader (if you don't want overlay)
    if (!showOverlay && isLoaderVisible) {
        return (
            <div className="flex min-h-[200px] items-center justify-center">
                <LoaderOverlay
                    text={loadingText}
                    mode={isProgressMode ? "progress" : "normal"}
                    progress={progress}
                    showOverlay={false}
                />
            </div>
        );
    }

    if (error) {
        return (
            <div className="p-4 text-sm text-red-600">
                {/* Never show the raw backend error in prod */}
                <p className="font-semibold">Something went wrong.</p>
                <p className="mt-1 text-xs text-slate-500">
                    {error.message || "Please try again later."}
                </p>
            </div>
        );
    }

    return <>{children}</>;
}
